import { Heading, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { useCredenciaisIntegracaoOldQuery } from 'graphql/hooks.generated'
import { CredencialIntegracaoQueryInput } from 'graphql/types.generated'
import React, { useState } from 'react'

import { CredenciaisIntegracaoFormOld } from './CredenciaisIntegracaoFormOld'
import { CredenciaisIntegracaoTableOld } from './CredenciaisIntegracaoTableOld'

export function CredenciaisIntegracaoBoxOld() {
  const [filter, setFilter] = useState<CredencialIntegracaoQueryInput>({ pageParams: { page: 0 } })

  const { data, loading, refetch } = useCredenciaisIntegracaoOldQuery({
    variables: {
      input: filter,
    },
  })

  return (
    <VFlow vSpacing={0.5}>
      <Heading level={3}>Credenciais para API</Heading>

      <Box>
        <VFlow>
          <CredenciaisIntegracaoFormOld refetch={refetch} />
          <CredenciaisIntegracaoTableOld data={data} loading={loading} setFilter={setFilter} refetch={refetch} />
        </VFlow>
      </Box>
    </VFlow>
  )
}
